import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { IDialogMessage } from 'src/app/@amiga-pyme/components/ami-dialog-message/ami-dialog-message.interface';
import { TokenService } from 'src/app/auth/services/token/token.service';
import { SunatReportService } from '../sunat-report.service';
import { IExportHistoryDto } from '../sunat-report.interface';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-new-exportation',
  templateUrl: './new-exportation.component.html',
  styleUrls: ['./new-exportation.component.scss']
})
export class NewExportationComponent implements OnInit {
  isLoading: boolean = false;
  message: IDialogMessage;

  selectedMonth: string = '';
  selectedYear: string = '';
  formatTxt: boolean = true;
  formatXls: boolean = true;

  businessId: any;
  userId: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private tokenService: TokenService,
    private sunatReportService: SunatReportService
  ) { }

  ngOnInit(): void {

    const now = new Date();
    this.selectedYear = String(now.getFullYear());
    this.selectedMonth = String(now.getMonth() + 1).padStart(2, '0');


    const token = this.tokenService.getTokenBody();
    this.businessId = (token as any).businessId || (token as any).id_business || (token as any).business?.id;
    this.userId = token.id;

    console.log('Business Context (Token):', token);
    console.log('Business ID:', this.businessId);
    console.log('User ID:', this.userId);
  }

  cancelWizard() {
    this.router.navigate(['../'], { relativeTo: this.route });
  }

  async generateExport() {
    this.message = { message: 'Generando archivos PLE...' };
    this.isLoading = true;

    const dto: IExportHistoryDto = {
      exportDate: new Date().toISOString(),
      periodMonth: Number(this.selectedMonth),
      periodYear: Number(this.selectedYear),
      isTxt: this.formatTxt,
      isXlsx: this.formatXls,
      userId: Number(this.userId),
      businessId: Number(this.businessId)
    };

    try {
      const response = await firstValueFrom(this.sunatReportService.exportHistory(dto));

      this.isLoading = false;
      this.message = { message: 'Archivos generados correctamente', status: 200 };
      setTimeout(() => {
        this.router.navigate(['../'], { relativeTo: this.route });
      }, 1500);

    } catch (error: any) {
      this.isLoading = false;
      this.message = {
        message: error.error?.message || 'Error al generar los archivos',
        status: error.status || 500
      };
      console.error('Export Error:', error);
    }
  }
}
